// import { Message } from 'iview';
import axios from 'axios';

import { Base64 } from 'js-base64';

import envConfig from '../../config';

const baseURL = envConfig[`VUE_APP_${envConfig.env.toUpperCase()}_BASE_URL`];

const instance = axios.create({
  baseURL,
  timeout: 300000,
});
// 响应拦截器
instance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

instance.interceptors.request.use(
  (request) => {
    /* eslint-disable no-param-reassign */
    if (request.params) {
      Object.keys(request.params).forEach((key) => {
        try {
          if (key !== 'dateTime') {
            request.params[key] = Base64.decode(request.params[key]);
          }
        } catch (e) {
          console.error(e);
        }
      });
    }
    if (request.data) {
      Object.keys(request.data).forEach((key) => {
        request.data[key] = Base64.decode(request.data[key]);
      });
    }
    if (!(request.params || request.data)) {
      const urlArr = request.url.split('/');
      urlArr[urlArr.length - 1] = Base64.decode(urlArr[urlArr.length - 1]);
      request.url = urlArr.join('/');
    }
    /* eslint-enable */
    return request;
  },
  (error) => {
    // do something with request error
    return Promise.reject(error);
  }
);

export default instance;
